"use client"
import React, {useEffect, useState} from "react";
import {checkCountryCodeListIncludeSearchString} from "./worldWiki.util";
import {Column} from "@/core/general/column.component";
import {WorldModel} from "@/core/tools/world_wiki/worldCountry.model";
import {useTranslations} from "use-intl";
import {SearchField} from "@/core/general/searchFiled.component";
import {Row} from "@/core/general/row.component";
import WorldData from './data/world.json';
import Twemoji from "react-twemoji";
import {getFlagEmoji} from "@/core/tools/world_wiki/worldWiki.component";

interface Props {
    itemClick: (model: WorldModel) => void
}

export default function WorldCountryList(props:Props) {

    const [worldList, setWorldList] = useState<WorldModel[]>([]);
    const [searchWorldList, setSearchWorldList] = useState<WorldModel[]>([]);
    const t = useTranslations();
    const [searchText, setSearchText] = useState('');
    const handleChange = (event: React.FormEvent<HTMLInputElement>) => {
        setSearchText(event.currentTarget.value);
        setSearchWorldList(checkCountryCodeListIncludeSearchString(worldList, event.currentTarget.value));
    };

    useEffect(() => {
        // @ts-ignore
        setWorldList(WorldData)
        // @ts-ignore
        setSearchWorldList(WorldData)
    }, [])

    return (
        <Column>
            <div className={"w-full mt-8 text-center font-bold"}>{t('profile.country')}</div>
            <SearchField searchTag={t('search')} type={'text'} searchText={searchText} onChangeText={handleChange} />
            {(searchWorldList && searchWorldList.length > 0) ? searchWorldList.map((item, index) =>
                <Row key={index} className={"px-4 py-2"} onClick={() => props.itemClick(item)}>
                    <Row className={"px-2 py-3 totalCenter card card-1 rounded-md pointer"}>
                        <Twemoji options={{ className: 'twemoji' }}>
                            <div className={"!w-8 !h-8 overflow-hidden"}>
                                {getFlagEmoji(item.Code)}
                            </div>
                        </Twemoji>
                        <div className={"px-2 text-black w-full text-start"}>{item?.Name}</div>
                        <div className={"px-2 text-black"}>{item?.Tel}+</div>
                    </Row>
                </Row>
            ) : null}
        </Column>
    )
}